import {IGameDescription, Localised} from "../../../common/types";
import {PageContainer} from "../../../common/components/page-container/PageContainer";
import React from "react";
import {getCurrentLang} from "../../../common/utils/lang";
import {GameInfoComponent} from "../../../common/components/game-info/GameInfoComponent";
import {QUESTIONS_GAME as GAME} from "../../../common/utils/games";

const gameDescription:Localised<IGameDescription> = require("./description.json");

const QuestionsGamePage = () => {
    const activeLang = getCurrentLang();

    return (
        <PageContainer fixedHeaderFooter={true}>
            <GameInfoComponent game={GAME} description={gameDescription[activeLang]}/>
        </PageContainer>
    );
};

export default QuestionsGamePage;
